module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("e slipped inside her body with a practiced ease from their many joinings. Although she softened beneath him, she gave no outward sign that she enjoyed this now as she had in the early days of their marriage. Judging from her reactions to his movements, it was most likely less now than then.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian moved them efficiently toward completion and, even as she let out a soft sigh, he offered a silent prayer that this time they might be successful in creating the heir he needed so much. For the dukedom, he prayed, as he filled her once more and felt his seed begin to release. For his family name and honor, he urged silently, as he thrust deeper within her again. For the continuation of his name, he implored, to whatever power controlled these matters.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Without a word, he withdrew from his wife. Climbing from her bed, he tugged on his robe and ran his fin")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("gers through his hair. When he heard the telltale sound of her shifting, and the rustling of the bedcovers, he turned toward the bed and nodded.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, my dear,” he said. He always said the same thing, since he appreciated his wife’s cooperation and efforts to gain an heir.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Windmere,” she replied softly, without ever meeting his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded at her and returned to his dressing room. Within the hour, the Duke of Windmere was at his club enjoying a particularly good port. And he realized, as the butler served him without him saying a word, that his life was nothing if not predictable.")])])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02921338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426878497_fm03.vue
// module id = 75
// module chunks = 0